/**
 * Login flow overhaul — which backend/database a session talks to:
 * live Production, the isolated Training database (`nexao_hmis_test`,
 * served by a second, fully independent backend process — see
 * `core/api/http-client.ts`'s baseURL resolution), or the isolated
 * Recovery database (`nexao_hmis_recovery`, rebuilt after
 * `nexao_hmis_prod`'s data loss — third fully independent backend
 * process, exposed only via `/recovered/login`, never selectable from
 * the normal login screen). Chosen on the login screen, before
 * credentials are submitted, and persisted so a page refresh mid-session
 * keeps hitting the same backend the user actually authenticated
 * against — switching environments while a session is still live would
 * silently send its bearer token to the wrong backend.
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Environment = 'production' | 'training' | 'recovery';

interface EnvironmentState {
  environment: Environment;
  setEnvironment: (environment: Environment) => void;
}

export const useEnvironmentStore = create<EnvironmentState>()(
  persist(
    (set) => ({
      environment: 'production',
      setEnvironment: (environment) => set({ environment }),
    }),
    { name: 'nexao-environment' },
  ),
);
